export default "__VITE_ASSET__3400b32d__"